import CreateDataContext from "./CreateData.context";

const initialState = {
  webDrawerStatus: false,
  mobileDrawerStatus: false,
};

const appReducer = (state, action) => {
  switch (action.type) {
    case "toggleWebDrawer":
      return { ...state, webDrawerStatus: action.payload };
    case "toggleMobileDrawer":
      return { ...state, mobileDrawerStatus: action.payload };
    default:
      return state;
  }
};

const toggleWebDrawer = (dispatch) => {
  return (initialState) => {
    dispatch({ type: "toggleWebDrawer", payload: initialState });
  };
};

const toggleMobileDrawer = (dispatch) => {
  return (initialState) => {
    dispatch({ type: "toggleMobileDrawer", payload: initialState });
  };
};

export const { Context, Provider } = CreateDataContext(
  appReducer,
  {
    toggleWebDrawer,
    toggleMobileDrawer,
  },
  initialState
);
